import Bowser from "bowser";
import {gettextCatalog} from "angular-gettext";
import {regNavn} from "./tredjepartsTjenestenavn";
import {Konfigurasjon} from "../infrastruktur/Konfigurasjon";
import {IWindowService} from "angular";
import Parser = Bowser.Parser.Parser;

export class KlientinformasjonFraUserAgent {

    static regNavn = "KlientinformasjonFraUserAgent";

    static forInjisering() {
        return [
            regNavn.ng.$window,
            Konfigurasjon.regNavn,
            regNavn.gettext.gettextCatalog,
            KlientinformasjonFraUserAgent
        ]
    }

    constructor(private $window:IWindowService, private konfigurasjon:Konfigurasjon, private gettextCatalog: gettextCatalog) {
        this._kallendeklientinformasjon = this.klientinformasjon(this.$window.navigator.userAgent, this.konfigurasjon.klientTypeErWeb())
    }

    private _kallendeklientinformasjon:Klientinformasjon;

    /** Returnerer klientinformasjon for kallende klient.
     * Se KlientinformasjonFraUserAgent.test.ts for eksempler. */
    kallendeklientinformasjon(): Klientinformasjon {
        return this._kallendeklientinformasjon;
    }

    /** Returnerer klientinformasjon basert på angitt userAgent.
     * Se KlientinformasjonFraUserAgent.test.ts for eksempler. */
    klientinformasjon(userAgent: string, erWebklient:boolean): Klientinformasjon {
        const klient: Parser = Bowser.getParser(userAgent);

        return {
            beskrivendeStreng: this.beskrivendeStreng(erWebklient, klient),
            osNavn: klient.getOSName(),
            osVersjon: klient.getOSVersion() ?? '', //på linux headless firefox returnerer getOSVersion() undefined
            nettleserNavn: klient.getBrowserName(),
            nettleserVersjon: klient.getBrowserVersion()
        }
    }

    private beskrivendeStreng(erWebklient: boolean, klient: Bowser.Parser.Parser) {
        if (erWebklient) {
            return this.gettextCatalog.getString('nettleser {{nettleser}} på {{os}}', {nettleser: klient.getBrowserName(), os: klient.getOSName()})
        } else {
            if (klient.getPlatform().model == 'iPhone')
                return this.gettextCatalog.getString('app på iPhone');
            else if (klient.getPlatform().model == 'iPad')
                return this.gettextCatalog.getString('app på iPad');
            else if (klient.getPlatform().type == 'mobile' && klient.getOS().name == 'Android')
                return this.gettextCatalog.getString('app på Android-telefon');
            else if (klient.getPlatform().type == 'tablet' && klient.getOS().name == 'Android')
                return this.gettextCatalog.getString('app på Android-nettbrett');
            else if (klient.getPlatform().type == 'mobile')
                return this.gettextCatalog.getString('app på telefon');
            else if (klient.getPlatform().type == 'tablet')
                return this.gettextCatalog.getString('app på nettbrett');
            else
                return this.gettextCatalog.getString('app på {{os}}', {os: klient.getOSName()})
        }
    }
}

export interface Klientinformasjon{
    beskrivendeStreng:string;
    osNavn:string;
    osVersjon:string;
    nettleserNavn:string
    nettleserVersjon:string;
}
